import React from 'react'
import PropTypes from 'prop-types'
import SearchForm from '../../../baseApp/shared/components/searchForm/SearchForm';
import {buildingsSearchFields} from '../utils/searchFields';
import DataTable from '../../../baseApp/shared/components/table/DataTable';
import {I18n} from 'react-redux-i18n';
import { appModules } from '../../../baseApp/roles/components/UserHasPermission';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const BuildingsPage = ({
    searchFieldsValues,
    universalSearchField,
    handleSearchFieldChange,
    handleUniversalSearchFieldChange,
    handleSearchSubmit,
    handleSearchClear,
    handleSortChanged,
    handleAddButtonClicked,
    data = [],
    entityList,
    onRowClick,
    pages = 0,
    currentPage = 0,
    pageSize,
    totalElements,
    sort: {
        property = "",
        direction = "ASC"
    },
    onPageChange,
    onPageSizeChange,
}) => {
    const columns = [{
        Header: I18n.t("buildings.list.name"),
        accessor: "name",
        sortable: true
    }, {
        Header: I18n.t('entities.types.company'),
        id: "parent",
        sortable: true,
        accessor: building => building.parent? building.parent.name : null,
    }, {
        Header: I18n.t('buildings.list.hasCheckInConfiguration'),
        id: 'hasCheckInConfiguration',
        accessor: building => building.hasCheckInConfiguration ?
            <FontAwesomeIcon icon={['fas', 'check']} style={{color: 'rgb(148, 206, 84)'}}/> :
            <FontAwesomeIcon icon={['fas', 'times']} style={{color: '#d17681'}}/>
    }, {
        Header: I18n.t('buildings.list.openTime'),
        accessor: "openTime"
    }, {
        Header: I18n.t('buildings.list.closeTime'),
        accessor: "closeTime"
    }];
    
    return <div className="page_background">
        <SearchForm
            content={buildingsSearchFields(searchFieldsValues, entityList)}
            universalSearchField={universalSearchField}
            handleFieldChange={handleSearchFieldChange}
            handleUniversalSearchFieldChange={handleUniversalSearchFieldChange}
            handleClear={handleSearchClear}
            handleSubmit={handleSearchSubmit}
            handleAddButtonClicked={handleAddButtonClicked}
            appModule={appModules.ENTITY}
        />
        <DataTable
            //State dependent
            data={data}
            onRowClick={onRowClick}

            //Pagination
            pages={pages}
            selectedPage={currentPage}
            pageSize={pageSize}
            sortDirection={direction}
            sortProperty={property}
            totalElements={totalElements}
            pageSizeOptions={[10, 20, 50]}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            onSortChanged={handleSortChanged}

            //State independent / Configuration
            columns={columns}
        />
    </div>
};

BuildingsPage.propTypes = {
    searchFieldsValues: PropTypes.object.isRequired,
    handleSearchFieldChange: PropTypes.func,
    handleSearchSubmit: PropTypes.func,
    handleSearchClear: PropTypes.func,
    data: PropTypes.array,
    pages: PropTypes.number
};

export default BuildingsPage;